import React, { useEffect, useState } from 'react'
import '../../UpdateOrganization.scss'
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import { Button, Grid, Typography, Backdrop } from '@mui/material';
import TextField from '../../../../components/SanitizedTextField/SanitizedTextField';
import AppLoader from '../../../../components/AppLoader/AppLoader';
import { Box } from '@mui/system';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { useLocation, useNavigate } from 'react-router-dom';
import { cfpBaseUrl } from '../../../../network/urls';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { documentValidation, handleFileUpload } from '../../../../services/Functions'
import { useSelector } from 'react-redux';

const COMPANY_PLACEHOLDER_ICON = 'data:image/png;base64,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';

const CompanyUpdateForm = () => {

  const initialValues = {
    iv_office_code: '',
    iv_company_name: '',
    iv_latitude: '',
    iv_longitude: '',
    iv_status: 0, //Active
    iv_is_store: 0,
    iv_cp1_name: '',
    iv_cp1_phone: '',
    iv_cp1_mobile: '',
    iv_cp1_email: '',
    iv_cp2_name: '',
    iv_cp2_phone: '',
    iv_cp2_mobile: '',
    iv_cp2_email: '',
    iv_bank_name: '',
    iv_erp_code: '',
    iv_capital_cost_account_no: '',
    iv_security_cost_account_no: ''
  }

  const [file, setFile] = useState('');
  const [fileError, setFileError] = useState("")
  const [fileThumbnail, setFileThumbnail] = useState('');
  const [companyState, setCompanyState] = useState();
  const { state } = useLocation();
  const { companyToEdit } = state;
  const [viewBackdrop, setViewBackdrop] = useState(false);

  const navigate = useNavigate()

  let { token, userId: updatedBy, permissions } = useSelector((state) => state.auth)

  const ProfilePicture = (event) => {
    if (event.target.files) {
      const newFileName = 'companyLogo.' + event.target.files[0].name.split(".").pop();
      handleFileUpload(event, handleChange, setFile, setFileError, setFileThumbnail, newFileName);
    }
  }

  useEffect(() => {
    setCompanyState(companyToEdit)
  }, [companyToEdit])

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_office_code: Yup.string().required('Enter office code.'),
      iv_company_name: Yup.string().required("Enter company name.").max(7, 'Company name can not be more than 7 characters.'),
      iv_latitude: Yup.string().required("Enter latitude."),
      iv_longitude: Yup.string().required("Enter longitude."),
      iv_status: Yup.mixed().required('Select status.'),
      iv_is_store: Yup.mixed().required('Select is store.'),
      iv_cp1_name: Yup.string().required("Fullname is required"),
      iv_cp1_phone: Yup.string().min(11, "Phone no. can not less than 11 digits.").max(11, "Phone no. can not greater than 11 digits.").required("Enter Phone No.").matches(/^0[0-9]{10}$/, "Enter Phone no. as 04237894561."),
      iv_cp1_mobile: Yup.string().min(11, "Mobile no. can not less than 11 digits.").max(11, "Mobile no. can not greater than 11 digits.").required("Enter Mobile No.").matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Mobile no. as 03001234567."),
      iv_cp1_email: Yup.string().email("Enter email as 'john@gmail.com'.").required('Enter email address.'),
      iv_cp2_name: Yup.string().required("Fullname is required"),
      iv_cp2_phone: Yup.string().min(11, "Phone no. can not less than 11 digits.").max(11, "Phone no. can not greater than 11 digits.").required("Enter Phone No.").matches(/^0[0-9]{10}$/, "Enter Phone no. as 04237894561."),
      iv_cp2_mobile: Yup.string().min(11, "Mobile no. can not less than 11 digits.").max(11, "Mobile no. can not greater than 11 digits.").required("Enter Mobile No.").matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Mobile no. as 03001234567."),
      iv_cp2_email: Yup.string().email("Enter email as 'john@gmail.com'.").required('Enter email address.'),
      iv_bank_name: Yup.string().required("Enter bank name."),
      iv_erp_code: Yup.string().required('Enter ERP code.'),
      iv_capital_cost_account_no: Yup.string().required("Enter account no. for capital cost."),
      iv_security_cost_account_no: Yup.string().required("Enter account no. for security cost."),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true)
      var formdata = new FormData();

      formdata.append("Companycode", values.iv_office_code);
      formdata.append("companyName", values.iv_company_name);
      formdata.append("cp1Name", values.iv_cp1_name);
      formdata.append("cp1phone", values.iv_cp1_phone);
      formdata.append("cp1Mobile", values.iv_cp1_mobile);
      formdata.append("cp1Email", values.iv_cp1_email);
      formdata.append("cp2Name", values.iv_cp2_name);
      formdata.append("cp2phone", values.iv_cp2_phone);
      formdata.append("cp2Mobile", values.iv_cp2_mobile);
      formdata.append("cp2Email", values.iv_cp2_email);
      formdata.append("longitude", values.iv_longitude);
      formdata.append("latitude", values.iv_latitude);
      formdata.append("status", values.iv_status);
      formdata.append("isStore", values.iv_is_store);
      formdata.append("updatedBy", updatedBy);
      formdata.append("compBankName", values.iv_bank_name);
      formdata.append("compErpCode", values.iv_erp_code);
      formdata.append("compCapitalCostAccountNo", values.iv_capital_cost_account_no);
      formdata.append("compSecurityAccountNo", values.iv_security_cost_account_no);
      formdata.append("companyLogo", fileThumbnail);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "customerFaciliationPortal/updateCompany", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === '200') {
            navigate('/company-management')
          } else {
          }
        })
        .catch(error => {
        });

      setViewBackdrop(false)

    }

  });

  useEffect(() => {
    if (companyState) {
      values.iv_office_code = companyState.companyCode
      values.iv_company_name = companyState.companyName
      values.iv_latitude = companyState.latitude
      values.iv_longitude = companyState.longitude
      values.iv_status = companyState.status
      values.iv_is_store = companyState.isStore
      values.iv_cp1_name = companyState.cp1Name
      values.iv_cp1_phone = companyState.cp1phone
      values.iv_cp1_mobile = companyState.cp1Mobile
      values.iv_cp1_email = companyState.cp1Email
      values.iv_cp2_name = companyState.cp2Name
      values.iv_cp2_phone = companyState.cp2phone
      values.iv_cp2_mobile = companyState.cp2Mobile
      values.iv_cp2_email = companyState.cp2Email
      values.iv_bank_name = companyState.compBankName
      values.iv_erp_code = companyState.compErpCode
      values.iv_capital_cost_account_no = companyState.compCapitalCostAccountNo
      values.iv_security_cost_account_no = companyState.compSecurityAccountNo
      setFileThumbnail(companyState.companyLogo)
    }
  }, [companyState])

  useEffect(() => {
    if (file) {
      values.iv_picture = fileThumbnail
    }
  }, [file])

  return (
    <>
      <Grid className='creation'>
        <Grid container className='creationContainer'>
          <Grid item lg={12} >
            <h3 className='heading'>
              Update Company
            </h3>
          </Grid>
          <Grid item lg={12} className='form'>
            <Grid container>
              <Grid item lg={12}>
                <Grid container spacing={1}>
                  <Grid item lg={12}>
                    <h4>Basic Information</h4>
                  </Grid>
                  <Grid item lg={12}>
                    <Grid container className="org-form-profile-row">
                  <Grid item className="org-logo-upload-col">
                    <Box className="org-logo-upload">
                      <Box className="org-logo-upload__ring">
                        <Box
                          component="img"
                          className={`org-logo-upload__image${fileThumbnail ? ' org-logo-upload__image--filled' : ''}`}
                          src={fileThumbnail || COMPANY_PLACEHOLDER_ICON}
                          alt="Company Logo"
                          onError={(e) => {
                            e.target.src = COMPANY_PLACEHOLDER_ICON;
                          }}
                        />
                        <Box
                          component="label"
                          htmlFor="update-company-logo-input"
                          className="org-logo-upload__btn"
                        >
                          <DriveFolderUploadIcon sx={{ fontSize: 22, color: 'inherit' }} />
                        </Box>
                        <input
                          type="file"
                          id="update-company-logo-input"
                          accept="image/jpeg,image/png,.jpg,.jpeg,.png"
                          onChange={ProfilePicture}
                          style={{ display: "none" }}
                        />
                      </Box>
                      <Typography className="org-logo-upload__hint" variant="caption">
                        JPEG or PNG - max 3 MB
                      </Typography>
                      {fileError ? (
                        <Typography className="org-logo-upload__error">
                          {fileError}
                        </Typography>
                      ) : null}
                    </Box>
                  </Grid>
                  <Grid item className="org-form-fields-col">
                    <Grid container >
                      <Grid item lg={3} sx={{ padding: '10px' }}>
                        <label>Office Code</label>
                        <TextField type='number' maxLength='5' onChange={handleChange} disabled name="iv_office_code" value={values.iv_office_code?values.iv_office_code:'-'} onBlur={handleBlur} sx={{
                          width: '100%', '.MuiInputBase-input': {
                            height: '1vh',
                          },
                        }} />
                        <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                          {errors.iv_office_code && touched.iv_office_code ? (errors.iv_office_code) : null}
                        </Grid>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '10px' }}>
                        <label>Company Name</label>
                        <TextField type='text' maxLength='5' onChange={handleChange} name="iv_company_name" value={values.iv_company_name?values.iv_company_name:'-'} onBlur={handleBlur} sx={{
                          width: '100%', '.MuiInputBase-input': {
                            height: '1vh',
                          },
                        }}
                          inputProps={{ maxLength: 7, autoComplete: "off" }} />
                        <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                          {errors.iv_company_name && touched.iv_company_name ? (errors.iv_company_name) : null}
                        </Grid>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '10px' }}>
                        <label>Latitude</label>
                        <TextField type='number' maxLength='5' onChange={handleChange} name="iv_latitude" value={values.iv_latitude?values.iv_latitude:'-'} onBlur={handleBlur} sx={{
                          width: '100%', '.MuiInputBase-input': {
                            height: '1vh',
                          },
                        }} />
                        <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                          {errors.iv_latitude && touched.iv_latitude ? (errors.iv_latitude) : null}
                        </Grid>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '10px' }}>
                        <label>Longitude</label>
                        <TextField type='number' maxLength='5' onChange={handleChange} name="iv_longitude" value={values.iv_longitude?values.iv_longitude:'-'} onBlur={handleBlur} sx={{
                          width: '100%', '.MuiInputBase-input': {
                            height: '1vh',
                          },
                        }} />
                        <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                          {errors.iv_longitude && touched.iv_longitude ? (errors.iv_longitude) : null}
                        </Grid>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '10px' }}>
                        <label>Status</label>
                        <Grid>
                          {
                            errors.iv_status && touched.iv_status ? (
                              <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_status}</p>
                            ) : null
                          }
                        </Grid>
                        <FormControl >
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="iv_status"
                            id="iv_status"
                            className='radio'
                            value={values.iv_status}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <FormControlLabel value={0} className='option-left' sx={{ padding: '0px 22.5px', marginRight: '15px', backgroundColor: 'white', borderRadius: '5px', marginLeft: '0px', border: '1px solid lightgrey' }} control={<Radio />} label='Active' />
                            <FormControlLabel value={1} className='option-left' sx={{ padding: '0px 22.5px', backgroundColor: 'white', borderRadius: '5px', marginLeft: '0px', border: '1px solid lightgrey' }} control={<Radio />} label='Inactive' />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '10px' }}>
                        <label>Is Store</label>
                        <Grid>
                          {
                            errors.iv_is_store && touched.iv_is_store ? (
                              <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_is_store}</p>
                            ) : null
                          }
                        </Grid>
                        <FormControl >
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="iv_is_store"
                            id="iv_is_store"
                            className='radio'
                            value={values.iv_is_store}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <FormControlLabel value={0} className='option-left' sx={{ padding: '0px 22.5px', marginRight: '15px', backgroundColor: 'white', borderRadius: '5px', marginLeft: '0px', border: '1px solid lightgrey' }} control={<Radio />} label='No' />
                            <FormControlLabel value={1} className='option-left' sx={{ padding: '0px 22.5px', backgroundColor: 'white', borderRadius: '5px', marginLeft: '0px', border: '1px solid lightgrey' }} control={<Radio />} label='Yes' />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={12}>
                <Grid container spacing={1}>
                  <Grid item lg={12}>
                    <h4>Bank Information</h4>
                  </Grid>
                  <Grid item lg={12}>
                    <Grid container sx={{ padding: '0px 10px' }}>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                        <Typography className="fieldLabel">Bank Name</Typography>
                        <TextField type='text' autoComplete='off' onChange={handleChange} name="iv_bank_name" value={values.iv_bank_name?values.iv_bank_name:'-'} onBlur={handleBlur} sx={{
                          width: '100%', '.MuiInputBase-input': {
                            height: '1vh',
                          },
                        }} />
                        <Grid className="from-Error">
                          {
                            errors.iv_bank_name && touched.iv_bank_name ? errors.iv_bank_name : null
                          }
                        </Grid>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                        <Typography className="fieldLabel">ERP Code</Typography>
                        <TextField
                          required
                          type="text"
                          name="iv_erp_code"
                          autoComplete="off"
                          value={values.iv_erp_code?values.iv_erp_code:'-'}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          inputProps={{ maxLength: 6 }}
                          id="iv_erp_code"
                          sx={{
                            width: '100%', '.MuiInputBase-input': {
                              height: '1vh',
                            },
                          }}
                        />
                        <Box className="from-Error">
                          {errors.iv_erp_code && touched.iv_erp_code
                            ? errors.iv_erp_code
                            : null}
                        </Box>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                        <Typography className="fieldLabel">Capital Cost Account No.</Typography>
                        <TextField
                          required
                          type="text"
                          name="iv_capital_cost_account_no"
                          autoComplete="off"
                          value={values.iv_capital_cost_account_no?values.iv_capital_cost_account_no:'-'}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          inputProps={{ maxLength: 14 }}
                          id="iv_capital_cost_account_no"
                          sx={{
                            width: '100%', '.MuiInputBase-input': {
                              height: '1vh',
                            },
                          }}
                        />
                        <Box className="from-Error">
                          {errors.iv_capital_cost_account_no && touched.iv_capital_cost_account_no
                            ? errors.iv_capital_cost_account_no
                            : null}
                        </Box>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }} >
                        <Typography className="fieldLabel">Security Cost Account No.</Typography>
                        <TextField
                          required
                          type="text"
                          name="iv_security_cost_account_no"
                          autoComplete="off"
                          value={values.iv_security_cost_account_no?values.iv_security_cost_account_no:'-'}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          inputProps={{ maxLength: 14 }}
                          id="iv_security_cost_account_no"
                          sx={{
                            width: '100%', '.MuiInputBase-input': {
                              height: '1vh',
                            },
                          }}
                        />
                        <Box className="from-Error">
                          {errors.iv_security_cost_account_no && touched.iv_security_cost_account_no
                            ? errors.iv_security_cost_account_no
                            : null}
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={12}>
                    <h4>First Contact Person Information</h4>
                  </Grid>
                  <Grid item lg={12}>
                    <Grid container sx={{ padding: '0px 10px' }}>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                        <Typography className="fieldLabel">Full Name</Typography>
                        <TextField type='text' autoComplete='off' onChange={handleChange} name="iv_cp1_name" value={values.iv_cp1_name?values.iv_cp1_name:'-'} onBlur={handleBlur} sx={{
                          width: '100%', '.MuiInputBase-input': {
                            height: '1vh',
                          },
                        }} />
                        <Grid className="from-Error">
                          {
                            errors.iv_cp1_name && touched.iv_cp1_name ? errors.iv_cp1_name : null
                          }
                        </Grid>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                        <Typography className="fieldLabel">Phone No.</Typography>
                        <TextField
                          required
                          type="text"
                          name="iv_cp1_phone"
                          autoComplete="off"
                          value={values.iv_cp1_phone?values.iv_cp1_phone:'-'}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          inputProps={{ maxLength: 11 }}
                          id="iv_cp1_phone"
                          sx={{
                            width: '100%', '.MuiInputBase-input': {
                              height: '1vh',
                            },
                          }}
                        />
                        <Box className="from-Error">
                          {errors.iv_cp1_phone && touched.iv_cp1_phone
                            ? errors.iv_cp1_phone
                            : null}
                        </Box>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                        <Typography className="fieldLabel">Mobile No.</Typography>
                        <TextField
                          required
                          type="text"
                          name="iv_cp1_mobile"
                          autoComplete="off"
                          value={values.iv_cp1_mobile?values.iv_cp1_mobile:'-'}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          inputProps={{ maxLength: 11 }}
                          id="iv_cp1_mobile"
                          sx={{
                            width: '100%', '.MuiInputBase-input': {
                              height: '1vh',
                            },
                          }}
                        />
                        <Box className="from-Error">
                          {errors.iv_cp1_mobile && touched.iv_cp1_mobile
                            ? errors.iv_cp1_mobile
                            : null}
                        </Box>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }} >
                        <Typography className="fieldLabel">Email</Typography>
                        <TextField
                          required
                          type="text"
                          name="iv_cp1_email"
                          autoComplete="off"
                          value={values.iv_cp1_email?values.iv_cp1_email:'-'}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          id="iv_cp1_email"
                          sx={{
                            width: '100%', '.MuiInputBase-input': {
                              height: '1vh',
                            },
                          }}
                        />
                        <Box className="from-Error">
                          {errors.iv_cp1_email && touched.iv_cp1_email
                            ? errors.iv_cp1_email
                            : null}
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={12}>
                    <h4>Second Contact Person Information</h4>
                  </Grid>
                  <Grid item lg={12}>
                    <Grid container sx={{ padding: '0px 10px', height: '20vh' }}>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                        <Typography className="fieldLabel">Full Name</Typography>
                        <TextField type='text' autoComplete='off' onChange={handleChange} name="iv_cp2_name" value={values.iv_cp2_name?values.iv_cp2_name:'-'} onBlur={handleBlur} sx={{
                          width: '100%', '.MuiInputBase-input': {
                            height: '1vh',
                          },
                        }} />
                        <Grid className="from-Error">
                          {
                            errors.iv_cp2_name && touched.iv_cp2_name ? errors.iv_cp2_name : null
                          }
                        </Grid>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                        <Typography className="fieldLabel">Phone No.</Typography>
                        <TextField
                          required
                          type="text"
                          name="iv_cp2_phone"
                          autoComplete="off"
                          value={values.iv_cp2_phone?values.iv_cp2_phone:'-'}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          inputProps={{ maxLength: 11 }}
                          id="iv_cp2_phone"
                          sx={{
                            width: '100%', '.MuiInputBase-input': {
                              height: '1vh',
                            },
                          }}
                        />
                        <Box className="from-Error">
                          {errors.iv_cp2_phone && touched.iv_cp2_phone
                            ? errors.iv_cp2_phone
                            : null}
                        </Box>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                        <Typography className="fieldLabel">Mobile No.</Typography>
                        <TextField
                          required
                          type="text"
                          name="iv_cp2_mobile"
                          autoComplete="off"
                          value={values.iv_cp2_mobile?values.iv_cp2_mobile:'-'}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          inputProps={{ maxLength: 11 }}
                          id="iv_cp2_mobile"
                          sx={{
                            width: '100%', '.MuiInputBase-input': {
                              height: '1vh',
                            },
                          }}
                        />
                        <Box className="from-Error">
                          {errors.iv_cp2_mobile && touched.iv_cp2_mobile
                            ? errors.iv_cp2_mobile
                            : null}
                        </Box>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }} >
                        <Typography className="fieldLabel">Email</Typography>
                        <TextField
                          required
                          type="text"
                          name="iv_cp2_email"
                          autoComplete="off"
                          value={values.iv_cp2_email?values.iv_cp2_email:'-'}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          id="iv_cp2_email"
                          sx={{
                            width: '100%', '.MuiInputBase-input': {
                              height: '1vh',
                            },
                          }}
                        />
                        <Box className="from-Error">
                          {errors.iv_cp2_email && touched.iv_cp2_email
                            ? errors.iv_cp2_email
                            : null}
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
              <Grid item lg={12} sx={{ padding: '0px 10px', textAlign: 'right' }}>
                <Button sx={{ width: '10%' }} variant="contained" size='medium' onClick={handleSubmit}>
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Backdrop */}
      < Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <AppLoader />
      </Backdrop >
    </>

  )
}

export default CompanyUpdateForm;
